import { render, staticRenderFns } from "./YouTubeImage.vue?vue&type=template&id=8d503688&scoped=true"
import script from "./YouTubeImage.vue?vue&type=script&lang=js"
export * from "./YouTubeImage.vue?vue&type=script&lang=js"
import style0 from "./YouTubeImage.vue?vue&type=style&index=0&id=8d503688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d503688",
  null
  
)

export default component.exports